var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tree.id)?_c('v-list-item',{staticClass:"pl-0",attrs:{"dense":""}},[_c('search-list-avatar',{staticClass:"my-0",attrs:{"type":_vm.tree.type}}),_c('search-list-content',{staticClass:"py-0",attrs:{"item":_vm.tree,"country-code":_vm.countryCode,"link":""}})],1):(_vm.treeId && !_vm.hideId)?_c('span',[_vm._v(_vm._s(_vm.treeId))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }